import { render, staticRenderFns } from "./EditDraw2d.vue?vue&type=template&id=af3177ba&scoped=true&"
import script from "./EditDraw2d.vue?vue&type=script&lang=ts&"
export * from "./EditDraw2d.vue?vue&type=script&lang=ts&"
import style0 from "./EditDraw2d.vue?vue&type=style&index=0&id=af3177ba&scoped=true&lang=css&"
import style1 from "./EditDraw2d.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3177ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
